import {FC} from 'react';
import {useTranslation} from 'react-i18next';
import DropdownSelect from 'components/Dropdown/DropdownSelect';
import InputText from 'components/Form/InputText';
import Radio from 'components/Form/Radio';
import Stacked from 'components/Layout/Stacked';
import {useBackend} from 'state/backend';
import {EmployeeRightsCreateBackendData} from '../types';
import UpgradeMessage from './UpgradeMessage';

type UserLicenseProps = {
    isCreatingNewEmployee?: boolean;
};

const UserLicense: FC<UserLicenseProps> = ({isCreatingNewEmployee}) => {
    const {t} = useTranslation('Team.Member.EmployeeRights');

    const {
        appPermissions: {canEditRights},
        data: {userLicense},
    } = useBackend<EmployeeRightsCreateBackendData>();

    return (
        <>
            {isCreatingNewEmployee && (
                <Stacked className="max-w-lg">
                    <div>
                        <p>
                            {t('headerText0', {
                                companyName: userLicense.companyName,
                            })}
                        </p>
                        <p>{t('headerText1')}</p>
                    </div>
                    <InputText
                        label={t('form:lastName')}
                        name="family_name"
                        required={true}
                    />
                    <InputText
                        label={t('form:firstName')}
                        name="given_name"
                        required={true}
                    />
                    <InputText
                        helpText={t('form:emailAddressHelpText')}
                        label={t('form:emailAddress')}
                        name="address"
                        required={true}
                    />
                    <DropdownSelect
                        aria-label={t('group')}
                        helpText={t('groupHelpText')}
                        isMultiChoices={true}
                        label={t('group')}
                        name="groups"
                        options={userLicense.groups}
                    />
                </Stacked>
            )}
            <div className="mt-4 flex flex-col gap-4">
                <UpgradeMessage />
                <Radio
                    className="my-4"
                    label={<h2 className="m-0">{t('userLicense')}</h2>}
                    name="user_license"
                    options={userLicense.options}
                    readOnly={!canEditRights.allowed}
                />
            </div>
        </>
    );
};

export default UserLicense;
